import React, { useState } from 'react';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';

export const ImageLazyloadContext = React.createContext({});

const ImageLazyloadProvider = ({ children }) => {
  // Don't try to reference document in the build process
  if (typeof document === 'undefined') return children;

  const [images, setImages] = useState([]);

  const resetLazyImages = () => {
    const images = document.querySelectorAll('.lazyload');
    setImages(images);
  }

  useIntersectionObserver(images, (image) => {
    image.target.src = image.target.dataset.src;
    image.target.classList.add('loaded');
  });

  return (
    <ImageLazyloadContext.Provider value={{ resetLazyImages }}>
      {children}
    </ImageLazyloadContext.Provider>
  );
};

export default ImageLazyloadProvider;
